<template>
  <div class="board-container">
    <div class="board">
      <Cell
        v-for="(cellValue, index) in board"
        :key="index"
        :cell-value="cellValue"
        :index="index"
        :piece-meta="pieceMetas[index] ?? null"
        :is-valid-move="validMoveSet.has(index)"
        :last-move-index="lastMoveIndex"
        :is-clickable="canInteract"
        :show-hint="!gameOver && canInteract"
        :move-gain="moveGainMap[index] ?? 0"
        :show-move-gain="showMoveGain && !gameOver && canInteract"
        :is-max-move-gain="
          showMoveGain &&
          !gameOver &&
          canInteract &&
          Number(moveGainMap[index]) === maxMoveGain
        "
        @click="handleCellClick"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Cell from '@/components/Cell/Cell.vue'

const props = defineProps({
  board: {
    type: Array,
    required: true
  },
  validMoveSet: {
    type: Set,
    required: true
  },
  lastMoveIndex: {
    type: Number,
    default: -1
  },
  canInteract: {
    type: Boolean,
    default: true
  },
  gameOver: {
    type: Boolean,
    default: false
  },
  pieceMetas: {
    type: Array,
    default: () => []
  },
  moveGainMap: {
    type: Object,
    default: () => ({})
  },
  showMoveGain: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['cell-click'])

const maxMoveGain = computed(() => {
  const values = Object.values(props.moveGainMap || {})
    .map((v) => Number(v))
    .filter((v) => Number.isFinite(v))
  if (values.length === 0) return -Infinity
  return Math.max(...values)
})

function handleCellClick(index) {
  emit('cell-click', index)
}
</script>

<style scoped>
.board-container {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
}

.board {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(8, 1fr);
  width: 100%;
  height: 100%;
  background-color: #15803d;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #15803d;
  gap: 1px;
}
</style>